<template>
  <div v-if="profileUser">
    <pull-to
      :on-refresh="onRefresh"
      style="width: 100%"
      :config="{
        errorLabel: $t('pullToRefreshError'),
        startLabel: $t('pullToRefreshLabel'),
        readyLabel: $t('pullToRefreshReady'),
        loadingLabel: $t('pullToRefreshLoading'),
        pullDownHeight: 100
      }"
    >
      <div class="profile-info-container">
        <div class="profile-info">
          <div class="profile-name">
            <span class="profile-name-text">{{ profileUser.name }}</span>
          </div>
          <div
            class="profile-button"
            v-if="isCurrentUser"
            @click="modalOpen = true"
          >
            <div class="profile-button-icon">
              <svg
                width="16px"
                height="16px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Icons/settings"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    d="M12,0.25 C13.5187831,0.25 14.75,1.48121694 14.75,3 L14.75,3 L14.75,3.08700877 C14.7514247,3.44572309 14.9657373,3.76933516 15.302824,3.91385306 C15.6394186,4.06240567 16.0325403,3.99112536 16.2896699,3.73966991 L16.2896699,3.73966991 L16.349375,3.67996499 C16.8651877,3.16357812 17.5651246,2.87342669 18.295,2.87342669 C19.0248754,2.87342669 19.7248123,3.16357812 20.240035,3.679375 C20.7564219,4.19518771 21.0465733,4.89512457 21.0465733,5.625 C21.0465733,6.35487543 20.7564219,7.05481229 20.2403301,7.57033009 L20.2403301,7.57033009 L20.1861469,7.62444872 C19.9288746,7.88745967 19.8575943,8.28058141 20.0061469,8.61717599 L20.0061469,8.61717599 L20.0254969,8.66549208 L20.0414151,8.71491393 L20.059,8.803 C20.2029787,9.04560794 20.4431397,9.20480665 20.712821,9.24177409 L20.712821,9.24177409 L20.83,9.25 L21,9.25 C22.5187831,9.25 23.75,10.4812169 23.75,12 C23.75,13.5187831 22.5187831,14.75 21,14.75 L21,14.75 L20.9129912,14.75 C20.5542769,14.7514247 20.2306648,14.9657373 20.0861469,15.302824 C19.9375943,15.6394186 20.0088746,16.0325403 20.2603301,16.2896699 L20.2603301,16.2896699 L20.320035,16.349375 C20.8364219,16.8651877 21.1265733,17.5651246 21.1265733,18.295 C21.1265733,19.0248754 20.8364219,19.7248123 20.320625,20.240035 C19.8048123,20.7564219 19.1048754,21.0465733 18.375,21.0465733 C17.6451246,21.0465733 16.9451877,20.7564219 16.4296699,20.2403301 L16.4296699,20.2403301 L16.3755513,20.1861469 C16.1125403,19.9288746 15.7194186,19.8575943 15.3754486,20.0093549 C15.0457373,20.1506648 14.8314247,20.4742769 14.83,20.83 L14.83,20.83 L14.83,21 C14.83,22.5187831 13.5987831,23.75 12.08,23.75 C10.5612169,23.75 9.33,22.5187831 9.33,21 L9.33,21 L9.33020509,20.9275384 C9.32156324,20.5580862 9.08795333,20.2314649 8.69717599,20.0861469 C8.36058141,19.9375943 7.96745967,20.0088746 7.71033009,20.2603301 L7.71033009,20.2603301 L7.650625,20.320035 C7.13481229,20.8364219 6.43487543,21.1265733 5.705,21.1265733 C4.97512457,21.1265733 4.27518771,20.8364219 3.75996499,20.320625 C3.24357812,19.8048123 2.95342669,19.1048754 2.95342669,18.375 C2.95342669,17.6451246 3.24357812,16.9451877 3.75966991,16.4296699 L3.75966991,16.4296699 L3.81385306,16.3755513 C4.07112536,16.1125403 4.14240567,15.7194186 3.99064513,15.3754486 C3.84933516,15.0457373 3.52572309,14.8314247 3.17,14.83 L3.17,14.83 L3,14.83 C1.48121694,14.83 0.25,13.5987831 0.25,12.08 C0.25,10.5612169 1.48121694,9.33 3,9.33 L3,9.33 L3.07246156,9.33020509 C3.44191384,9.32156324 3.7685351,9.08795333 3.91385306,8.69717599 C4.06240567,8.36058141 3.99112536,7.96745967 3.73966991,7.71033009 L3.73966991,7.71033009 L3.67996499,7.650625 C3.16357812,7.13481229 2.87342669,6.43487543 2.87342669,5.705 C2.87342669,4.97512457 3.16357812,4.27518771 3.679375,3.75996499 C4.19518771,3.24357812 4.89512457,2.95342669 5.625,2.95342669 C6.35487543,2.95342669 7.05481229,3.24357812 7.57033009,3.75966991 L7.57033009,3.75966991 L7.62444872,3.81385306 C7.88745967,4.07112536 8.28058141,4.14240567 8.61717599,3.99385306 L8.61717599,3.99385306 L8.66549208,3.97450314 L8.71491393,3.95858489 L8.803,3.94 C9.04560794,3.7970213 9.20480665,3.55686034 9.24177409,3.28717904 L9.24177409,3.28717904 L9.25,3.17 L9.25,3 C9.25,1.48121694 10.4812169,0.25 12,0.25 Z M12,1.75 C11.3096441,1.75 10.75,2.30964406 10.75,3 L10.75,3 L10.75,3.17299123 C10.7461789,4.12956276 10.1746786,4.99252827 9.29544858,5.36935487 C9.20208841,5.40936783 9.10157342,5.43 9,5.43 L9,5.43 L9.072,5.425 L9.05288031,5.43357408 C8.25268689,5.71636747 7.3606182,5.55437519 6.70615511,5.00415587 L6.70615511,5.00415587 L6.56966991,4.88033009 L6.509375,4.82003501 C6.27491468,4.5853137 5.95676156,4.45342669 5.625,4.45342669 C5.29323844,4.45342669 4.97508532,4.5853137 4.74003501,4.820625 C4.5053137,5.05508532 4.37342669,5.37323844 4.37342669,5.705 C4.37342669,6.03676156 4.5053137,6.35491468 4.74033009,6.58966991 L4.74033009,6.58966991 L4.80614694,6.65555128 C5.4922064,7.3569138 5.68228724,8.40523845 5.30390208,9.25888582 L5.30390208,9.25888582 L5.23844347,9.41890926 C4.86080924,10.2550045 4.03375955,10.8081176 3.09,10.83 L3.09,10.83 L3,10.83 C2.30964406,10.83 1.75,11.3896441 1.75,12.08 C1.75,12.7703559 2.30964406,13.33 3,13.33 L3,13.33 L3.17299123,13.330006 C4.12956276,13.3338211 4.99252827,13.9053214 5.36614694,14.777176 C5.76228724,15.6747615 5.5722064,16.7230862 4.88033009,17.4303301 L4.88033009,17.4303301 L4.82003501,17.490625 C4.5853137,17.7250853 4.45342669,18.0432384 4.45342669,18.375 C4.45342669,18.7067616 4.5853137,19.0249147 4.820625,19.259965 C5.05508532,19.4946863 5.37323844,19.6265733 5.705,19.6265733 C6.03676156,19.6265733 6.35491468,19.4946863 6.58966991,19.2596699 L6.58966991,19.2596699 L6.65555128,19.1938531 C7.3569138,18.5077936 8.40523845,18.3177128 9.25888582,18.6960979 L9.25888582,18.6960979 L9.41890926,18.7615565 C10.2550045,19.1391908 10.8081176,19.9662405 10.83,20.91 L10.83,20.91 L10.83,21 C10.83,21.6903559 11.3896441,22.25 12.08,22.25 C12.7703559,22.25 13.33,21.6903559 13.33,21 L13.33,21 L13.330006,20.8270088 C13.3338211,19.8704372 13.9053214,19.0074717 14.777176,18.6338531 C15.6747615,18.2377128 16.7230862,18.4277936 17.4303301,19.1196699 L17.4303301,19.1196699 L17.490625,19.179965 C17.7250853,19.4146863 18.0432384,19.5465733 18.375,19.5465733 C18.7067616,19.5465733 19.0249147,19.4146863 19.259965,19.179375 C19.4946863,18.9449147 19.6265733,18.6267616 19.6265733,18.295 C19.6265733,17.9632384 19.4946863,17.6450853 19.2596699,17.4103301 L19.2596699,17.4103301 L19.1938531,17.3444487 C18.5077936,16.6430862 18.3177128,15.5947615 18.7106451,14.7045514 C19.0874717,13.8253214 19.9504372,13.2538211 20.91,13.25 L20.91,13.25 L21,13.25 C21.6903559,13.25 22.25,12.6903559 22.25,12 C22.25,11.3096441 21.6903559,10.75 21,10.75 L21,10.75 L20.8270088,10.75 C19.8704372,10.7461789 19.0074717,10.1746786 18.6306451,9.29544858 C18.5906322,9.20208841 18.57,9.10157342 18.57,9 L18.574,9.073 L18.5126147,8.88012411 C18.308755,8.12646078 18.4849262,7.31387083 18.9958441,6.70615511 L18.9958441,6.70615511 L19.1196699,6.56966991 L19.179965,6.509375 C19.4146863,6.27491468 19.5465733,5.95676156 19.5465733,5.625 C19.5465733,5.29323844 19.4146863,4.97508532 19.179375,4.74003501 C18.9449147,4.5053137 18.6267616,4.37342669 18.295,4.37342669 C17.9632384,4.37342669 17.6450853,4.5053137 17.4103301,4.74033009 L17.4103301,4.74033009 L17.3444487,4.80614694 C16.6430862,5.4922064 15.5947615,5.68228724 14.7045514,5.28935487 C13.8253214,4.91252827 13.2538211,4.04956276 13.25,3.09 L13.25,3.09 L13.25,3 C13.25,2.30964406 12.6903559,1.75 12,1.75 Z M12,8.25 C14.0710678,8.25 15.75,9.92893219 15.75,12 C15.75,14.0710678 14.0710678,15.75 12,15.75 C9.92893219,15.75 8.25,14.0710678 8.25,12 C8.25,9.92893219 9.92893219,8.25 12,8.25 Z M12,9.75 C10.7573593,9.75 9.75,10.7573593 9.75,12 C9.75,13.2426407 10.7573593,14.25 12,14.25 C13.2426407,14.25 14.25,13.2426407 14.25,12 C14.25,10.7573593 13.2426407,9.75 12,9.75 Z"
                    id="Combined-Shape"
                    fill="#111111"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="profile-button-text">
              <span>{{ $t("profileEditProfilebutton") }}</span>
            </div>
          </div>
          <div
            class="profile-button"
            v-else-if="profileUser.doIFollow"
            @click="followHandler"
          >
            <div class="profile-button-icon">
              <svg
                width="16px"
                height="16px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Icons/follow-filled"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="users"
                    transform="translate(1.000000, 2.000000)"
                    :fill="color"
                  >
                    <path
                      d="M12.75,12 C15.3004817,12 17.3814697,14.0101413 17.4951121,16.532572 L17.5,16.75 L17.5,18.75 C17.5,19.1642136 17.1642136,19.5 16.75,19.5 L0.75,19.5 L0.75,19.5 C0.370304234,19.5 0.0565090391,19.2178461 0.006846616,18.8517706 L0,18.75 L0,16.75 C0,14.1995183 2.01014129,12.1185303 4.532572,12.0048879 L4.75,12 L12.75,12 Z M8.75,0 C11.3733526,0 13.5,2.12664744 13.5,4.75 C13.5,7.37335256 11.3733526,9.5 8.75,9.5 C6.12664744,9.5 4,7.37335256 4,4.75 C4,2.12664744 6.12664744,0 8.75,0 Z M18.75,1 C19.1296958,1 19.443491,1.28215388 19.4931534,1.64822944 L19.5,1.75 L19.5,4 L21.75,4 C22.1642136,4 22.5,4.33578644 22.5,4.75 C22.5,5.12969577 22.2178461,5.44349096 21.8517706,5.49315338 L21.75,5.5 L19.5,5.5 L19.5,7.75 C19.5,8.16421356 19.1642136,8.5 18.75,8.5 C18.3703042,8.5 18.056509,8.21784612 18.0068466,7.85177056 L18,7.75 L18,5.5 L15.75,5.5 C15.3357864,5.5 15,5.16421356 15,4.75 C15,4.37030423 15.2821539,4.05650904 15.6482294,4.00684662 L15.75,4 L18,4 L18,1.75 C18,1.33578644 18.3357864,1 18.75,1 Z"
                      id="Combined-Shape"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="profile-button-text">
              <span>{{ $t("profileUnfollowingbutton") }}</span>
            </div>
          </div>
          <div class="profile-button" v-else @click="followHandler">
            <div class="profile-button-icon">
              <svg
                width="16px"
                height="16px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Icons/follow"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="users"
                    transform="translate(1.000000, 2.000000)"
                    fill="#111111"
                  >
                    <path
                      d="M12.75,12 C15.3004817,12 17.3814697,14.0101413 17.4951121,16.532572 L17.5,16.75 L17.5,18.75 C17.5,19.1642136 17.1642136,19.5 16.75,19.5 C16.3703042,19.5 16.056509,19.2178461 16.0068466,18.8517706 L16,18.75 L16,16.75 C16,15.0169685 14.6435452,13.6007541 12.9344239,13.5051448 L12.75,13.5 L4.75,13.5 C3.01696854,13.5 1.60075407,14.8564548 1.50514479,16.5655761 L1.5,16.75 L1.5,18.75 C1.5,19.1642136 1.16421356,19.5 0.75,19.5 C0.370304234,19.5 0.0565090391,19.2178461 0.006846616,18.8517706 L0,18.75 L0,16.75 C0,14.1995183 2.01014129,12.1185303 4.532572,12.0048879 L4.75,12 L12.75,12 Z M8.75,0 C11.3733526,0 13.5,2.12664744 13.5,4.75 C13.5,7.37335256 11.3733526,9.5 8.75,9.5 C6.12664744,9.5 4,7.37335256 4,4.75 C4,2.12664744 6.12664744,0 8.75,0 Z M18.75,1 C19.1296958,1 19.443491,1.28215388 19.4931534,1.64822944 L19.5,1.75 L19.5,4 L21.75,4 C22.1642136,4 22.5,4.33578644 22.5,4.75 C22.5,5.12969577 22.2178461,5.44349096 21.8517706,5.49315338 L21.75,5.5 L19.5,5.5 L19.5,7.75 C19.5,8.16421356 19.1642136,8.5 18.75,8.5 C18.3703042,8.5 18.056509,8.21784612 18.0068466,7.85177056 L18,7.75 L18,5.5 L15.75,5.5 C15.3357864,5.5 15,5.16421356 15,4.75 C15,4.37030423 15.2821539,4.05650904 15.6482294,4.00684662 L15.75,4 L18,4 L18,1.75 C18,1.33578644 18.3357864,1 18.75,1 Z M8.75,1.5 C6.95507456,1.5 5.5,2.95507456 5.5,4.75 C5.5,6.54492544 6.95507456,8 8.75,8 C10.5449254,8 12,6.54492544 12,4.75 C12,2.95507456 10.5449254,1.5 8.75,1.5 Z"
                      id="Combined-Shape"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="profile-button-text">
              <span>{{ $t("profileFollowingbutton") }}</span>
            </div>
          </div>
        </div>
        <div
          class="profile-info"
          style=" border-bottom: 1px solid  #F6F6F6;padding-bottom: 16px;"
        >
          <div class="profile-img">
            <figure
              class="image"
              style="width: 70px;height: 70px;margin: 0 5px;"
              @click="isCurrentUser ? (modalOpen = true) : {}"
            >
              <img
                class="is-rounded"
                v-lazysizes
                :src="
                  profileUser.avatar !== '' && profileUser.avatar
                    ? profileUser.avatar
                    : defaultImage
                "
                @error="userImageErrorHandler"
                :style="{
                  border: '2px solid ' + color,
                  objectFit: 'cover',
                  height: '100%',
                  padding: '2px'
                }"
              />
            </figure>
          </div>
          <div class="profile-fields-container">
            <div class="profile-fields-row">
              <div style="margin: 0 5px">
                <p class="profile-fields-number" v-if="lang === 'ar'">
                  {{ videosNumber | arabicize }}
                </p>
                <p class="profile-fields-number" v-else>
                  {{ videosNumber }}
                </p>
                <p class="profile-fields-text">
                  {{ $t("profileVideoLabel") }}
                </p>
              </div>
              <div style="margin: 0 5px">
                <p v-if="lang === 'ar'" class="profile-fields-number">
                  {{ profileUser.followers | arabicize }}
                </p>
                <p class="profile-fields-number" v-else>
                  {{ profileUser.followers }}
                </p>
                <p class="profile-fields-text">
                  {{ $t("profileFollowersLabel") }}
                </p>
              </div>
              <div style="margin: 0 5px">
                <p v-if="lang === 'ar'" class="profile-fields-number">
                  {{ profileUser.following | arabicize }}
                </p>
                <p class="profile-fields-number" v-else>
                  {{ profileUser.following }}
                </p>
                <p class="profile-fields-text">
                  {{ $t("profileFollowingLabel") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </pull-to>
    <div
      class="profile-main-container"
      :style="{ height: screenHeight - 220 + 'px' }"
    >
      <div class="profile-points">
        <div class="profile-points-icon">
          <svg
            width="19px"
            height="19px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="Icons/points"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <path
                d="M16.5832653,2.02462585 C20.1189569,2.02462585 22.9954649,4.90113379 22.9954649,8.4368254 C22.9954649,9.85287982 22.5671202,11.3321995 21.7221315,12.8395465 C22.2982766,13.7473923 22.632381,14.8232653 22.632381,15.9757823 C22.632381,19.2124263 19.9991837,21.8456236 16.7625397,21.8456236 C15.59678,21.8456236 14.5093424,21.5039909 13.5950113,20.9156463 C13.1918821,21.1944218 12.7804082,21.4695692 12.3669388,21.7367347 L12.3669388,21.7367347 L11.9977324,21.9753288 L11.6285261,21.7367347 C9.7752381,20.5391837 7.10888889,18.6311565 4.93097506,16.3421769 C2.32258503,13.6008163 1,10.9410431 1,8.4368254 C1,4.90113379 3.87650794,2.02462585 7.41219955,2.02462585 C8.43773243,2.02462585 9.41791383,2.25972789 10.3254875,2.72344671 C10.9433107,3.03909297 11.5107937,3.45836735 11.9977324,3.95591837 C12.4847166,3.45836735 13.0521995,3.03904762 13.6699773,2.72344671 C14.5775057,2.25972789 15.5577324,2.02462585 16.5832653,2.02462585 Z M16.7625397,11.4665306 C14.2761451,11.4665306 12.253288,13.4893878 12.253288,15.9758277 C12.253288,18.4622676 14.2760998,20.4851247 16.7625397,20.4851247 C19.2489796,20.4851247 21.2718367,18.4622676 21.2718367,15.9758277 C21.2718367,13.4893878 19.2489342,11.4665306 16.7625397,11.4665306 Z M16.5833107,3.38517007 C14.9796372,3.38517007 13.5064853,4.12181406 12.5416327,5.4061678 L12.5416327,5.4061678 L11.9977324,6.13020408 L11.4538322,5.4061678 C10.4889796,4.12181406 9.01587302,3.38517007 7.41219955,3.38517007 C4.62671202,3.38517007 2.36054422,5.65133787 2.36054422,8.4368254 C2.36054422,10.5802268 3.55696145,12.9244444 5.91664399,15.4043537 C7.86303855,17.4500227 10.2338776,19.1890249 11.9977324,20.3529252 C12.1678458,20.2406803 12.3370068,20.1270295 12.5053515,20.0127891 C11.5064853,18.9599093 10.8927891,17.5382766 10.8927891,15.975873 C10.8927891,12.739229 13.525941,10.1060317 16.762585,10.1060317 C18.3175057,10.1060317 19.7329252,10.7140136 20.784263,11.7043991 C21.3490703,10.5702948 21.634966,9.47437642 21.634966,8.4368254 C21.634966,5.65133787 19.3687982,3.38517007 16.5833107,3.38517007 Z M17.4428118,13.1814966 L17.4428118,15.2956009 L19.5569161,15.2956009 L19.5569161,16.6561451 L17.4428118,16.6561451 L17.4428118,18.7702041 L16.0822676,18.7702041 L16.0822676,16.6561451 L13.9681633,16.6561451 L13.9681633,15.2956009 L16.0822676,15.2956009 L16.0822676,13.1814966 L17.4428118,13.1814966 Z"
                id="Combined-Shape"
                fill="#111111"
              ></path>
            </g>
          </svg>
        </div>
        <div class="profile-points-number">
          <span v-if="lang === 'ar'">{{ points | arabicize }}</span>
          <span v-else>{{ points }}</span>
        </div>
        <div
          class="profile-points-button"
          @click="openRedeemModalHandler"
          v-if="isCurrentUser"
        >
          <span>{{ $t("redeemPointsButton") }}</span>
        </div>
      </div>
      <div class="profile-videos-container">
        <div class="profile-videos-title">
          <span>{{ $t("profileVideosTitle") }}</span>
        </div>
        <div class="profile-videos">
          <div v-if="profileVideos.length === 0">
            <h3
              :style="{
                color: color,
                textAlign: 'center',
                lineHeight: 3,
                fontSize: '18px'
              }"
            >
              {{ $t("noVideos") }}
            </h3>
            <div class="profile-no-video">
              <img :src="arrow" style="height: 100%" />
            </div>
          </div>
          <div
            v-else
            style="margin: 20px 0 50px 0"
            :key="indexC"
            v-for="(video, indexC) in profileVideos"
          >
            <div v-if="video.videos.length > 0">
              <div v-for="(v, index) in video.videos" :key="index">
                <user-video
                  v-if="isCurrentUser"
                  :video="v"
                  :indexC="indexC"
                  :index="index"
                  :currentUser="currentUser"
                  :clickLike="clickLikeHandler"
                  :submitNewComment="submitNewComment"
                >
                  <VideosComponent
                    :index="v._id"
                    :id="v.uri"
                    :videosListProps="video.videos"
                  />
                </user-video>
                <user-video
                  v-else-if="v.isApproved"
                  :video="v"
                  :index="index"
                  :indexC="indexC"
                  :currentUser="currentUser"
                  :clickLike="clickLikeHandler"
                  :submitNewComment="submitNewComment"
                >
                  <VideosComponent
                    :index="v._id"
                    :id="v.uri"
                    :videosListProps="video.videos"
                  />
                </user-video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-profile
      v-if="modalOpen"
      :modalOpen="modalOpen"
      :closeModal="closeModal"
      :userProps="profileUser"
    ></edit-profile>
    <redeem-point
      v-if="modalRedeemOpen"
      :modalOpen="modalRedeemOpen"
      :closeModal="closeRedeemModal"
      :videos="profileVideos"
    ></redeem-point>
  </div>
</template>
<script>
import PullTo from "vue-pull-refresh";
import EditProfile from "./EditProfile.vue";
import RedeemPoint from "./RedeemPoint.vue";
import UserVideo from "./UserVideo.vue";
import VideosComponent from "../VideoCard/VideoComponent";
import Arrow from "@/assets/mainImage/arrowDown.png";
export default {
  data() {
    return {
      modalOpen: false,
      modalRedeemOpen: false,
      isCurrentUser: false,
      file: null,
      arrow: Arrow
    };
  },
  created() {
    if (this.$route.params.userId === this.$store.getters.currentUser) {
      this.isCurrentUser = true;
    } else {
      this.isCurrentUser = false;
    }
  },
  components: {
    EditProfile,
    RedeemPoint,
    UserVideo,
    PullTo,
    VideosComponent
  },
  props: ["profileUser", "profileVideos", "onRefresh"],
  computed: {
    points() {
      if (this.profileUser.wallet) {
        if (typeof this.profileUser.wallet.points !== "undefined") {
          return this.profileUser.wallet.points;
        }
      }
      return "";
    },
    videosNumber() {
      let num = 0;
      if (this.profileVideos.length > 0) {
        for (let i = 0; i < this.profileVideos.length; ++i) {
          num += this.profileVideos[i].videos.length;
        }
      }
      return num;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    defaultImage() {
      return this.$store.getters.brandLogo;
    },
    screenHeight() {
      return this.$store.getters.screenHeight - 70;
    },
    cssVariable() {
      return {
        "--color": this.$store.getters.primaryColor,
        "--bkcolor": this.$store.getters.secondaryColor
      };
    },
    color() {
      return this.$store.getters.primaryColor;
    },
    bkcolor() {
      return this.$store.getters.secondaryColor;
    },
    lang() {
      return this.$store.getters.lang;
    }
  },
  methods: {
    userImageErrorHandler(e) {
      e.target.src = this.defaultImage;
    },
    openRedeemModalHandler() {
      const now = new Date().getTime();
      const endCounter = this.$store.getters.countdown * 1000;
      if (endCounter - now <= 172800627) {
        let message = "";
        let lang = localStorage.getItem("lang");
        if (lang === "0") {
          message =
            "you can not redeem points now please try in the next round ";
        } else {
          message =
            "لا يمكنك استبدال النقاط الآن يرجى المحاولة في الجولة القادمة";
        }
        notie.alert({ type: "error", text: message });
      } else if (this.points > 0) {
        if (this.videosNumber > 0) {
          this.modalRedeemOpen = true;
        } else {
          let message = "";
          let lang = localStorage.getItem("lang");
          if (lang === "0") {
            message = "please add a video";
          } else {
            message = "الرجاء إضافة فيديو إلى حسابك";
          }
          notie.alert({ type: "error", text: message });
        }
      } else {
        let message = "";
        let lang = localStorage.getItem("lang");
        if (lang === "0") {
          message = "You Don't have points to redeem";
        } else {
          message = "ليس لديك نقاط";
        }
        notie.alert({ type: "error", text: message });
      }
    },
    followHandler() {
      this.$store.dispatch("followHandler", this.$route.params.userId);
    },
    closeModal() {
      this.modalOpen = false;
    },
    closeRedeemModal() {
      this.modalRedeemOpen = false;
    },
    clickLikeHandler(data) {
      this.$store.dispatch("likeButtonHandler", data);
    },
    submitNewComment(value) {
      this.$store.dispatch("newCommentHandler", value);
    }
  },
  filters: {
    arabicize: function(value) {
      const arabicNums = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
      return value.toString().replace(/[0-9]/g, function(w) {
        return arabicNums[+w];
      });
    }
  }
};
</script>

<style scoped>
.profile-info-container {
  margin: 0 20px;
}
.profile-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.profile-name {
  flex: 1;
  text-align: start;
}
.profile-name-text {
  color: #101010;
  font-family: Cairo;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 37px;
}
.profile-button {
  width: 20%;
  border-radius: 6px;
  background-color: #f6f6f6;
  padding: 7px 6px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.profile-button-icon {
  flex: 1;
}
.profile-button-text {
  flex: 3;
  height: 100%;
  text-align: center;
  color: #101010;
  font-family: Cairo;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 23px;
}
.profile-img {
  width: 25%;
}
.profile-fields-container {
  flex: 1;
}
.profile-fields-row {
  display: flex;
  margin: 0 5px;
  justify-content: space-around;
  align-items: center;
}
.profile-fields-number {
  color: #101010;
  font-family: Cairo;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  margin-bottom: 0 !important;
}
.profile-fields-text {
  color: #101010;
  font-family: Cairo;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 23px;
  margin-bottom: 0 !important;
}
.profile-main-container {
  overflow-y: scroll;
  /* -webkit-overflow-scrolling: touch; */
  overflow-x: hidden;
}
.profile-points {
  margin: 13px 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.profile-points-number {
  width: 10%;
  margin: 0 4px;
  color: #101010;
  font-family: Cairo;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 37px;
  text-align: start;
}
.profile-points-button {
  padding: 5px 10px;
  border-radius: 6px;
  background-color: #f6f6f6;
  color: #101010;
  font-family: Cairo;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 23px;
  margin: 0 10px;
}
.profile-videos-title {
  margin: 0 20px;
  color: #101010;
  font-family: Cairo;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  text-align: start;
}
.profile-videos {
  margin-bottom: 50px;
}
.profile-no-video {
  margin: 10px auto;
  width: 100%;
  height: 150px;
  opacity: 0.3;
  text-align: center;
}
</style>
